import useApiService from "../../../hooks/useApiService";
import styles from "./dashboard.module.css";
import { Dashboard } from "../../../models/interface.dashboard";
import { useToast } from "../../../context/ToastContext";
import { capitaliseEveryFirstLetter } from "../../../utils/generalUtils";
import { Link } from "react-router-dom";
import { RouteComponentProps } from "../../../models/RouteComponent";
import { useEffect } from "react";

function SiteDashboard(props: RouteComponentProps) {
  const toast = useToast();

  const { data, loading } = useApiService<Dashboard>({
    url: "site-dashboard",
    method: "GET",
    apiName: "core",
    onError: error => {
      toast("error", error.message || "Error loading dashboard data");
    },
    onSuccess: data => {
      console.log("data", data);
    },
    cache: {
      enabled: true,
      strategy: "cache-first",
      ttlMs: 5 * 60_000,
      key: `GET::core::site-dashboard:${props.session.site_id}::contentOnly`,
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [loading]);

  function generateLink(key: keyof Dashboard) {
    switch (key) {
      case "employeeCount":
        return `/site-employee-table`;
      case "equipmentCount":
        return `/site-equipment-table`;
      case "vehicleCount":
        return `/site-vehicle-table`;
      case "chemicalCount":
        return `/site-chemical-table`;
      case "jobTaskCount":
        return `/scope-of-work/job-tasks`;
      default:
        return `/dashboard`;
    }
  }

  return (
    <div className={styles["responsive-grid-4"]}>
      {data &&
        Object.keys(data || {}).map(key => {
          const count = Number(data[key as keyof Dashboard]);
          let stripClass = styles.success;
          if (count === 0) stripClass = styles.danger;
          else if (count < 10) stripClass = styles.warning;
          return (
            <Link to={generateLink(key as keyof Dashboard)} key={key} className={styles.card}>
              <div className={styles["card-content"]}>
                <p>{capitaliseEveryFirstLetter(key.split("Count")[0])} Count:</p>
                <span>{count}</span>
              </div>
              <div className={`${styles["card-strip"]} ${stripClass}`}></div>
            </Link>
          );
        })}
    </div>
  );
}

export default SiteDashboard;
